import { render, staticRenderFns } from "./baseDetailDialog.vue?vue&type=template&id=5ac57112&"
import script from "./baseDetailDialog.vue?vue&type=script&lang=js&"
export * from "./baseDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports